
import AgricultureStatsPropertyView from "./AgricultureStatsPropertyView";
import AgricultureStatsSectionView from "./AgricultureStatsSectionView";
import { MaintenanceResult } from "types/agriculture/states-type";

const AgricultureStatsMaintenance = (props: { maintenance: MaintenanceResult | undefined | null }) => {

    if (!props.maintenance) {
        return <></>;
    }

    return <AgricultureStatsSectionView title="agriculture.stats.maintenance">
        <div className="flex flex-wrap">
            <AgricultureStatsPropertyView label="agriculture.stats.expenses" value={props.maintenance?.totalExpense} propertyType="money" />
            <AgricultureStatsPropertyView label="agriculture.stats.interactions" value={props.maintenance?.totalCount} propertyType="number" />
            <AgricultureStatsPropertyView label="agriculture.stats.working-days" value={props.maintenance?.totalDays} propertyType="number" />
            <AgricultureStatsPropertyView label="agriculture.stats.workers-count" value={props.maintenance?.totalWorkers} propertyType="number" />
        </div>
    </AgricultureStatsSectionView>
};

export default AgricultureStatsMaintenance;
